export { default } from './Alert';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/Alert/index.js
// module id = 1676
// module chunks = 121